import React, { useState, useEffect } from 'react';
import Card from './Card.js';
import './Album.css';

function Album(props) {
  /* -------------------------------------------------------------------------- */
  /*                                    State                                   */
  /* -------------------------------------------------------------------------- */
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastURL, setLastURL] = useState();
  const [error, setError] = useState(false);

  /* -------------------------------------------------------------------------- */
  /*                               Fetch Petition                               */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    if (data[0] == undefined || props.url !== lastURL) {
      setLastURL(props.url)
      setLoading(true)
      var ListaDeDatos = fetch(props.url)
        .then(response => response.json())
        .then(jsondata => {
          setLoading(false)
          if (jsondata.data.count>0){
            setError(false)
            setData(jsondata.data.results)
            props.limitCharge(jsondata.data.total)
          }else{
            setData([])
            props.limitCharge(0)
            setError(true)
          }
        });
    }
  }, [props.url])

  const renderCards = () => {
    if (loading) {
      return (
        <div>
          Cargando...
        </div>
      )
    }else if (error){
      return(
      <div>
        No hay resultados para tu busqueda
      </div>)
    }
    else{
      return (
        data.map(i => {
          return <Card key={i.id} name={i.name} img={i.thumbnail.path + '/standard_fantastic.' + i.thumbnail.extension} description={i.description} linkURL={i.urls[1].url}/>
        })
      )
  }
    }

  /* -------------------------------------------------------------------------- */
  /*                                     JSX                                    */
  /* -------------------------------------------------------------------------- */
  return (
    <div className='album'>
      {renderCards()}
    </div>
  )
}

export default Album;